import { saveAs } from "file-saver";
import axios from "axios";
import { apiVariable } from "./apiVariable";

const getNormalizedExtension = (fileName?: string | null) => {
  const extension = fileName?.split(".").pop()?.trim().toLowerCase();
  return extension && extension.length > 0 ? extension : null;
};

const getDownloadFileName = (row: any, type: string, extension: string) => {
  if (type === "departmentTicket") {
    return (
      row.fileName ?? row.storedFileName ?? `${row.id}-${type}.${extension}`
    );
  }

  return `${row.id}-${type}.${extension}`;
};

export const handleDownloadFile = async (
  row: any,
  type: string,
  token: string | null | undefined,
  unitNumber?: string | null,
) => {
  const preferredExtension = getNormalizedExtension(
    row.fileName ?? row.storedFileName,
  );
  const extensions = [preferredExtension, "pdf", "jpg", "jpeg", "png"].filter(
    (extension, index, allExtensions): extension is string =>
      !!extension && allExtensions.indexOf(extension) === index,
  );
  let found = false;

  for (const extension of extensions) {
    try {
      const url = `${apiVariable}/download/${row.id}/${type}/${extension}`;
      const response = await axios.get(url, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        ...(type === "personalFolder"
          ? {
              params: {
                fileName: `${row.fileName}`,
                employeeName: `${row.firstName + " " + row.lastName}`,
              },
            }
          : type === "assetFolder"
            ? {
                params: {
                  fileName: `${row.fileName}`,
                  unitNumber: `${unitNumber}`,
                },
              }
            : type === "departmentTicket" && row.storedFileName
              ? {
                  params: {
                    fileName: `${row.storedFileName}`,
                  },
                }
              : null),
      });

      if (response.status === 200) {
        saveAs(response.data, getDownloadFileName(row, type, extension));
        found = true;
        break;
      }
    } catch (error: any) {
      if (error.response && error.response.status === 500) {
        console.log(
          `File with extension ${extension} not found, trying next...`,
        );
      } else {
        console.error("Download error:", error);
        alert("An error occurred while downloading the file.");
        return;
      }
    }
  }

  if (!found) {
    alert("No file found for the given ID and type.");
  }
};
